import { render, staticRenderFns } from "./online-serve.vue?vue&type=template&id=3fb83830&scoped=true&"
import script from "./online-serve.vue?vue&type=script&lang=js&"
export * from "./online-serve.vue?vue&type=script&lang=js&"
import style0 from "./online-serve.vue?vue&type=style&index=0&id=3fb83830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb83830",
  null
  
)

export default component.exports